import React, { useEffect, useState } from "react"
import PageMetaTags from "components/PageMetaTags"
import { Col, Container, Row, Spinner } from "reactstrap"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import { connect } from "react-redux"
import { withRouter, generatePath } from "react-router-dom"
import {
  getAllFeatureReports,
  getEventInfoList,
  getEventInviteList,
  getFeatureUsageReport,
  getSelectedEvent,
  resetAppOpensReports,
  resetBasicContentList,
  resetCommentBoardList,
  resetCountdownClockList,
  resetDocumentList,
  resetEventInfoList,
  resetEventInviteList,
  resetFeatureUsageReport,
  resetFormBuilderList,
  resetListOfLists,
  resetMediaGalleryList,
  resetPollList,
  resetQuestionnaireList,
  resetSelectedEvent,
  resetSurveyList,
  resetTriviaList,
  resetWebLinkList,
} from "store/actions"
import PollsCard from "../Polls/pollsCard"
import SurveysCard from "../Surveys/surveysCard"
import FormBuildersCard from "../FormBuilders/formBuildersCard"
import QuestionnairesCard from "../Questionnaires/questionnairesCard"
import TriviasCard from "../Trivias/triviasCard"
import { SaveButton } from "components/Buttons"
import EventInfoCard from "../EventInfo/eventInfoCard"
import LinksCard from "../Links/linksCard"
import ModalComponent from "components/Modals"
import EngagementTrendsModal from "./engagementTrendsModal"
import FeatureUsageModal from "./featureUsageModal"
import UsersCard from "./usersCard"
import EngagementTrendsCard from "./engagementTrendsCard"
import FeatureUsageCard from "./featureUsageCard"
import UsersModal from "./usersModal"
import BasicContentCard from "../BasicContent/basicContentCard"
import DocumentCard from "../Documents/documentCard"
import CommentBoardCard from "../CommentBoard/commentBoardCard"
import CountdownClockCard from "../CountdownClock/countdownClockCard"
import MediaGalleryCard from "../MediaGallery/mediaGalleryCard"
import CardWithoutData from "../CardWithoutData"
import { URL_PATHS } from "constants/index"
import ListsCard from "../Lists/listsCard"

const EventReports = ({
  history,
  match,
  pollList,
  surveyList,
  formBuilderList,
  questionnaireList,
  triviaChallengeList,
  getEvent,
  selectedEvent,
  resetPollList,
  resetSurveyList,
  resetQuestionnaireList,
  resetTriviaList,
  resetFormBuilderList,
  resetEventInfoList,
  eventInfoList,
  webLinkList,
  resetWebLinkList,
  vendorId,
  getFeatureUsageReport,
  getEventInviteList,
  resetEventInviteList,
  resetAppOpensReports,
  resetFeatureUsageReport,
  resetBasicContentList,
  basicContentList,
  resetDocumentList,
  documentList,
  resetCommentBoardList,
  commentBoardList,
  countdownClockList,
  resetCountdownClockList,
  resetMediaGalleryList,
  mediaGalleryList,
  resetListOfLists,
  listOfLists,
  featureReportsLoading,
  getAllFeatureReports,
  resetSelectedEvent
}) => {
  const FEATURES_WITHOUT_DATA = [
    {
      machine_name: "calendar",
      title: "Calendars",
      feature_pathname: URL_PATHS.CALENDAR_REPORTS,
    },
    {
      machine_name: "guest_list",
      title: "Attendee List",
      feature_pathname: URL_PATHS.ATTENDEE_LIST_REPORTS,
    },
    {
      machine_name: "refer_friend",
      title: "Refer a Friend",
      feature_pathname: URL_PATHS.REFER_FRIEND_REPORTS,
    },
    {
      machine_name: "private_message",
      title: "Private Message",
      feature_pathname: URL_PATHS.PRIVATE_MESSAGE_REPORTS,
    },
    {
      machine_name: "leaderboard",
      title: "Leaderboard",
      feature_pathname: URL_PATHS.LEADERBOARD_REPORTS,
    },
    {
      machine_name: "camera",
      title: "Camera",
      feature_pathname: URL_PATHS.CAMERA_REPORTS,
    },
    {
      machine_name: "bookings",
      title: "Bookings",
      feature_pathname: URL_PATHS.BOOKING_CALENDAR_REPORTS,
    },
  ]
  const [engagementTrendsModalIsOpen, setEngagementTrendsModalIsOpen] =
    useState(false)
  const [featureUsageModalIsOpen, setFeatureUsageModalIsOpen] = useState(false)
  const [usersModalIsOpen, setUsersModalIsOpen] = useState(false)
  const [featuresToDisplay, setFeaturesToDisplay] = useState([])

  useEffect(() => {
    if (match?.params?.id) {
      getEvent(match?.params?.id)
      getFeatureUsageReport({
        event_id: match?.params?.id,
      })
      getAllFeatureReports({
        per_page: 5,
        event_id: match?.params?.id,
      })
    }
    return () => {
      resetPollList()
      resetSurveyList()
      resetQuestionnaireList()
      resetTriviaList()
      resetFormBuilderList()
      resetEventInfoList()
      resetWebLinkList()
      resetEventInviteList()
      resetAppOpensReports()
      resetFeatureUsageReport()
      resetBasicContentList()
      resetDocumentList()
      resetCommentBoardList()
      resetCountdownClockList()
      resetMediaGalleryList()
      resetListOfLists()
      resetSelectedEvent()
    }
  }, [])

  useEffect(() => {
    if (vendorId) {
      getEventInviteList(vendorId, match?.params?.id, {
        o: "name",
        od: "asc",
        perPage: 15,
      })
    }
  }, [vendorId])

  useEffect(() => {
    if (selectedEvent?.design?.menu) {
      const featureNames = selectedEvent.design.menu.map(
        item => item?.machine_name
      )
      const availableFeatures = FEATURES_WITHOUT_DATA.filter(feature => {
        if (feature.machine_name === "bookings") {
          return (
            featureNames.includes("booking_service") ||
            featureNames.includes("view_bookings")
          )
        }
        return featureNames.includes(feature?.machine_name)
      })
      setFeaturesToDisplay(availableFeatures)
    }
  }, [selectedEvent])

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Experience Reports" />
        <Container fluid>
          <BreadcrumbTitle
            title={
              !!selectedEvent?.name && (
                <>
                  <span className="font-size-18">{selectedEvent?.name} </span>
                  <span
                    style={{
                      fontWeight: "normal",
                      textTransform: "none",
                      fontSize: "14px",
                    }}
                  >
                    (
                    <span
                      style={{ color: "-webkit-link", cursor: "pointer" }}
                      onClick={() => {
                        history.push(`/events/${vendorId}/${selectedEvent?.id}`)
                      }}
                    >
                      edit
                    </span>
                    )
                  </span>
                </>
              )
            }
            breadcrumbItems={[
              { title: "Dashboard" },
              { title: "Experience Reports" },
            ]}
          />
          <Row className="d-flex justify-content-end">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>
          {featureReportsLoading && (
            <Row className="d-flex justify-content-center">
              <Spinner className="ms-2" color="primary" />
            </Row>
          )}
          <Row className="mt-3">
            <Col xl={4} xs={12} className="d-flex flex-row flex-grow-1">
              <EngagementTrendsCard
                handleViewMore={() => {
                  setEngagementTrendsModalIsOpen(true)
                }}
                eventId={match?.params?.id}
              />
            </Col>
            <Col xl={4} xs={12} className="d-flex flex-row flex-grow-1">
              <FeatureUsageCard
                handleViewMore={() => {
                  setFeatureUsageModalIsOpen(true)
                }}
              />
            </Col>
            <Col xl={4} xs={12} className="d-flex flex-row flex-grow-1">
              <UsersCard
                handleViewMore={() => {
                  setUsersModalIsOpen(true)
                }}
                eventId={match?.params?.id}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            {pollList?.data?.length > 0 && (
              <PollsCard data={pollList?.data} eventId={match?.params?.id} />
            )}
            {surveyList?.data?.length > 0 && (
              <SurveysCard
                data={surveyList?.data}
                eventId={match?.params?.id}
              />
            )}
            {formBuilderList?.data?.length > 0 && (
              <FormBuildersCard
                data={formBuilderList?.data}
                eventId={match?.params?.id}
              />
            )}
            {questionnaireList?.data?.length > 0 && (
              <QuestionnairesCard
                data={questionnaireList?.data}
                eventId={match?.params?.id}
              />
            )}
            {triviaChallengeList?.data?.length > 0 && (
              <TriviasCard
                data={triviaChallengeList?.data}
                eventId={match?.params?.id}
              />
            )}
            {eventInfoList?.data?.length > 0 && (
              <EventInfoCard
                data={eventInfoList?.data}
                eventId={match?.params?.id}
              />
            )}
            {webLinkList?.data?.length > 0 && (
              <LinksCard data={webLinkList?.data} eventId={match?.params?.id} />
            )}
            {basicContentList?.data?.length > 0 && (
              <BasicContentCard
                data={basicContentList?.data}
                eventId={match?.params?.id}
              />
            )}
            {listOfLists?.data?.length > 0 && (
              <ListsCard data={listOfLists?.data} eventId={match?.params?.id} />
            )}
            {documentList?.data?.length > 0 && (
              <DocumentCard
                data={documentList?.data}
                eventId={match?.params?.id}
              />
            )}
            {commentBoardList?.data?.length > 0 && (
              <CommentBoardCard
                data={commentBoardList?.data}
                eventId={match?.params?.id}
              />
            )}
            {countdownClockList?.data?.length > 0 && (
              <CountdownClockCard
                data={countdownClockList?.data}
                eventId={match?.params?.id}
              />
            )}
            {mediaGalleryList?.data?.length > 0 && (
              <MediaGalleryCard
                data={mediaGalleryList?.data}
                eventId={match?.params?.id}
              />
            )}
            {featuresToDisplay.map(feature => (
              <CardWithoutData
                eventId={match?.params?.id}
                title={feature?.title}
                pathname={generatePath(feature?.feature_pathname, {
                  event_id: match?.params?.id,
                })}
              />
            ))}
          </Row>
        </Container>
      </div>
      <ModalComponent
        title="Engagement Trends"
        open={engagementTrendsModalIsOpen}
        size="xl"
        onClose={() => setEngagementTrendsModalIsOpen(false)}
      >
        <EngagementTrendsModal eventId={match?.params?.id} />
      </ModalComponent>
      <ModalComponent
        title="Feature Usage"
        open={featureUsageModalIsOpen}
        size="xl"
        onClose={() => setFeatureUsageModalIsOpen(false)}
      >
        <FeatureUsageModal />
      </ModalComponent>
      <ModalComponent
        title="Users"
        open={usersModalIsOpen}
        size="xl"
        scrollable={true}
        onClose={() => setUsersModalIsOpen(false)}
      >
        <UsersModal eventId={match?.params?.id} />
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  pollList: state.Poll.pollList,
  surveyList: state.Survey.surveyList,
  formBuilderList: state.FormBuilder.formBuilderList,
  triviaChallengeList: state.TriviaChallenge.triviaChallengeList,
  questionnaireList: state.Questionnaire.questionnaireList,
  selectedEvent: state.experiences.selectedEvent,
  eventInfoList: state.EventInfo.eventInfoList,
  webLinkList: state.WebLink.webLinkList,
  vendorId: state.Login.vendorId,
  basicContentList: state.BasicContent.basicContentList,
  documentList: state.Document.documentList,
  commentBoardList: state.CommentBoard.commentBoardList,
  countdownClockList: state.CountdownClock.countdownClockList,
  mediaGalleryList: state.MediaGallery.mediaGalleryList,
  listOfLists: state.List.listOfLists,
  featureReportsLoading: state.Analytics.featureReportsLoading,
})

const mapDispatchToProps = dispatch => ({
  getEvent: values => dispatch(getSelectedEvent(values)),
  resetPollList: () => dispatch(resetPollList()),
  resetSurveyList: () => dispatch(resetSurveyList()),
  resetFormBuilderList: () => dispatch(resetFormBuilderList()),
  resetTriviaList: () => dispatch(resetTriviaList()),
  resetQuestionnaireList: () => dispatch(resetQuestionnaireList()),
  getEventInfoList: values => dispatch(getEventInfoList(values)),
  resetEventInfoList: () => dispatch(resetEventInfoList()),
  resetWebLinkList: () => dispatch(resetWebLinkList()),
  getFeatureUsageReport: values => dispatch(getFeatureUsageReport(values)),
  getEventInviteList: (vendorId, eventId, sortOptions) =>
    dispatch(getEventInviteList(vendorId, eventId, sortOptions)),
  resetEventInviteList: () => dispatch(resetEventInviteList()),
  resetAppOpensReports: () => dispatch(resetAppOpensReports()),
  resetFeatureUsageReport: () => dispatch(resetFeatureUsageReport()),
  resetBasicContentList: () => dispatch(resetBasicContentList()),
  resetDocumentList: () => dispatch(resetDocumentList()),
  resetCommentBoardList: () => dispatch(resetCommentBoardList()),
  resetCountdownClockList: () => dispatch(resetCountdownClockList()),
  resetMediaGalleryList: () => dispatch(resetMediaGalleryList()),
  resetListOfLists: () => dispatch(resetListOfLists()),
  getAllFeatureReports: values => dispatch(getAllFeatureReports(values)),
  resetSelectedEvent: () => dispatch(resetSelectedEvent())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(EventReports))
